module.exports = __webpack_public_path__ + "img/Icon_home_register.6a192535.svg";